import React from 'react'
import Input from '../Input'
import {Controller, useFormContext} from 'react-hook-form'
import {useTranslation} from 'react-i18next'

const FormInput = ({
    name,
    rules,
    label,
    required,
    type,
    i18nCategory,
    variant,
    readOnly,
    defaultValue,
    error,
    ...p
}) => {
    const {control} = useFormContext()
    const {t} = useTranslation()

    return (
        <Controller
            name={name}
            control={control}
            rules={rules}
            render={({field: {onChange}}) => {
                const handleChange = (e) => {
                    const value = e.target.value
                    if (type === 'number') {
                        onChange(value === '' ? '' : Number(value))
                    } else {
                        onChange(value)
                    }
                }
                return (
                    <Input
                        {...p}
                        onChange={handleChange}
                        value={defaultValue}
                        label={t(`${i18nCategory}.${label}`)}
                        required={required}
                        disabled={readOnly}
                        type={type}
                        variant={variant}
                        error={!!error}
                        helperText={error?.message && t(`error.${error?.message}`)}
                    />
                )
            }}
        />
    )
}

export default FormInput
